<div *ngIf="siteSettings?.defaultSettings?.member_plan[2] !== 1">
    Page is Unavailable. Please contact admin
</div>
<div class="row match-height justify-content-center" *ngIf="siteSettings?.defaultSettings?.member_plan[2] == 1">
    <div class="col-md-12">
        <div class="content-wrapper container-xxl p-0">
            <div class="content-body">
                <app-content-header [contentHeader]="contentHeader"></app-content-header>

                <div class="row match-height">
                    <!-- Membership Plans Section -->
                    <div class="col-lg-12 col-12">
                        <div class="card">
                            <div class="card-header">
                                <h4 class="card-title">Membership Plans</h4>
                            </div>
                            <div class="card-body">
                                <!-- Plan Cards -->
                                <div class="row">
                                    <div *ngFor="let plan of selectBasic" class="col-md-4">
                                        <div class="card" [style.border]="currentPlan === plan.id ? '2px solid red' : 'none'">
                                            <div class="card-body">
                                                <h5 class="card-title">{{ plan.plan_name }}</h5>
                                                <div [innerHTML]="plan.descc"></div>
                                                <p class="card-text">Price: {{ plan.plan_price | currency: "₦" }}</p>
                                                <span *ngIf="submitted">
                                                    <button disabled="true" *ngIf="currentPlan !== plan.id" class="btn btn-primary">Upgrading...</button>
                                                </span>
                                                <span *ngIf="!submitted">
                                                    <button (click)="subscribe(plan.id)" *ngIf="currentPlan !== plan.id" class="btn btn-primary">Upgrade Plan</button>
                                                </span>
                                                <button *ngIf="currentPlan === plan.id" class="btn btn-default">Current Plan</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
